module.exports = __webpack_public_path__ + "assets/img/my-vip-page-bg3.455c0482.png";